import React from 'react';
import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint.es.js';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import { useDisclosure } from '../../hooks/useDisclosure/useDisclosure.es.js';
import 'react-beautiful-dnd';
import '../../utils/assertions.es.js';
import { runIfFn } from '../../utils/functions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'nanoid/non-secure';
import { Drawer } from '../Drawer/Drawer.es.js';
import Button from '../Button/Button.es.js';
import { Box } from '../../primitives/Box/Box.es.js';
import { MOBILE_BREAKPOINT, Content } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductHeaderCollapse = (props) => {
  const _a = props, { children, triggerLabel } = _a, rest = __objRest(_a, ["children", "triggerLabel"]);
  const isMobile = useBreakpoint(MOBILE_BREAKPOINT);
  const { isOpen, onOpen, onClose } = useDisclosure();
  return isMobile ? /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(Button, {
    variant: "ghost",
    kind: "link",
    onClick: onOpen,
    isDropdown: true
  }, triggerLabel), /* @__PURE__ */ React.createElement(Drawer, __spreadValues({
    isVisible: isOpen,
    onClose
  }, rest), /* @__PURE__ */ React.createElement(Box, {
    py: "xs"
  }, runIfFn(children, { isOpen, onClose })))) : /* @__PURE__ */ React.createElement(Content, null, runIfFn(children, { isOpen, onClose }));
};
ProductHeaderCollapse.displayName = "ProductHeader.Collapse";

export { ProductHeaderCollapse };
//# sourceMappingURL=ProductHeaderCollapse.es.js.map
